// extracted by mini-css-extract-plugin
module.exports = {"grid":"grid_grid__3bnl5"};